import React from 'react';
import { createPortal } from 'react-dom';

type PortalProviderProps = { nodeId: string };

const PortalProvider: React.FunctionComponent<PortalProviderProps> = ({
  children,
  nodeId,
}): React.ReactPortal | null => {
  const portalRoot = document.getElementById(nodeId);

  return portalRoot && createPortal(children, portalRoot);
};

export default PortalProvider;
